import { render, staticRenderFns } from "./SelectClientModal.vue?vue&type=template&id=fda1192a"
import script from "./SelectClientModal.vue?vue&type=script&lang=js"
export * from "./SelectClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports